import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../baseQuery';

export interface SkillRadarEntry {
	key: string;
	name: string;
	level: number | null;
	sampleCount: number;
	note?: string;
}

export interface SkillProfile {
	skills: { key: string; name: string; definition: string }[];
	levels: { value: number; label: string }[];
	maxLevel: number;
	sessionsScored: number;
	updatedAt: string | null;
	radar: SkillRadarEntry[];
}

export interface SkillAggregate {
	skills: { key: string; name: string; definition: string }[];
	levels: { value: number; label: string }[];
	maxLevel: number;
	studentsScored: number;
	radar: SkillRadarEntry[];
	weakest?: SkillRadarEntry[];
}

export const skillInsightsApi = createApi({
	reducerPath: 'skillInsightsApi',
	baseQuery: axiosBaseQuery,
	tagTypes: ['SkillProfile'],
	endpoints: (builder) => ({
		getMySkillProfile: builder.query<SkillProfile, void>({
			query: () => ({ url: '/skill-insights/me' }),
			providesTags: ['SkillProfile'],
		}),
		getStudentSkillProfile: builder.query<SkillProfile, string>({
			query: (id) => ({ url: `/skill-insights/student/${id}` }),
			providesTags: (_r, _e, id) => [{ type: 'SkillProfile', id }],
		}),
		getClassSkillProfile: builder.query<SkillAggregate, string>({
			query: (id) => ({ url: `/skill-insights/class/${id}` }),
		}),
		getSchoolSkillProfile: builder.query<SkillAggregate, string | void>({
			query: (schoolId) => ({
				url: schoolId
					? `/skill-insights/school?school_id=${schoolId}`
					: '/skill-insights/school',
			}),
		}),
		getAllSchoolsSkillProfile: builder.query<SkillAggregate, void>({
			query: () => ({ url: '/skill-insights/all' }),
		}),
	}),
});

export const {
	useGetMySkillProfileQuery,
	useGetStudentSkillProfileQuery,
	useGetClassSkillProfileQuery,
	useGetSchoolSkillProfileQuery,
	useGetAllSchoolsSkillProfileQuery,
} = skillInsightsApi;
